'use client';

import { ReactNode } from 'react';

import { GeoLevel } from '@/types';

import { GeoLevelContext } from './context';

export type GeoLevelProviderProps = {
    children: ReactNode;
    levels: GeoLevel[];
};

export function GeoLevelProvider({ children, levels }: GeoLevelProviderProps) {
    return <GeoLevelContext value={levels}>{children}</GeoLevelContext>;
}
